import { useState } from "react";

import {
  EmailSender,
  SettingsHeader,
} from "components/settings";
import { useBreadcrumbs } from "context/useBreadcrumbs";
import { RouteLinks } from "services/router.service";

import "./EmailSenderSettings.scss";

const EmailSenderSettings = () => {
  const [ activeTab, setActiveTab ] = useState("email-sender");

  useBreadcrumbs([
    { url: RouteLinks.PROTECTED.SETTINGS.GENERAL, label: "Settings" },
    { label: "Email Sender" },
  ]);

  return (
    <div className="default-page-wrapper">
      <SettingsHeader
        activeTab={ activeTab }
        setActiveTab={ setActiveTab }
      />
      { activeTab === "email-sender" && <EmailSender/> }
    </div>
  );
};

export default EmailSenderSettings; 
